import actions from "./actions";

export default {
  namespaced: true,
  state: {
    aiTools: []
  },
  mutations: {
    setAiTools(state, tools) {
      state.aiTools = tools;
    }
  },
  actions
};
